import angular from "angular";
import { vsComponentName } from "./component";
import { SelectMachineModalConfig } from "./controller";

export const vsServiceName = "selectMachineModalService";

export class SelectMachineModalService {
  static $inject = ["$uibModal"];

  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  openModal(
    config?: SelectMachineModalConfig
  ): angular.ui.bootstrap.IModalInstanceService {
    return this.$uibModal.open({
      component: vsComponentName,
      resolve: {
        machineModalConfig: () => config,
      },
    });
  }
}
